import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { setLiveFxRates } from "@/lib/format";

let fetchPromise = null;

function fetchFxRatesOnce() {
  if (!fetchPromise) {
    fetchPromise = api.get("/fx-rates").catch((e) => {
      fetchPromise = null;
      throw e;
    });
  }
  return fetchPromise;
}

export function useFxRates() {
  const [state, setState] = useState({ ready: false, live: false, asOf: null });

  useEffect(() => {
    fetchFxRatesOnce()
      .then((r) => {
        setLiveFxRates(r.data.rates, r.data.rate_date);
        setState({ ready: true, live: r.data.source === "frankfurter", asOf: r.data.rate_date });
      })
      .catch(() => setState({ ready: true, live: false, asOf: null }));
  }, []);

  return state;
}
